import { usePage } from "@inertiajs/react";
import { useEffect, useRef } from "react";
import { toast } from "sonner";

interface PageProps {
  flash?: {
    success?: string;
    alert?: string;
    notice?: string;
    error?: string;
  };
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  [key: string]: any;
}

export default function FlashMessages() {
  const { flash } = usePage<PageProps>().props;
  const previousFlash = useRef<typeof flash>(undefined);

  useEffect(() => {
    // Only show toasts if flash has changed (avoid showing on initial mount with same message)
    if (flash && flash !== previousFlash.current) {
      if (flash.success) {
        toast.success(flash.success);
      }

      if (flash.notice) {
        toast.info(flash.notice);
      }

      if (flash.alert) {
        toast.error(flash.alert);
      }

      if (flash.error) {
        toast.error(flash.error);
      }

      previousFlash.current = flash;
    }
  }, [flash]);

  return null;
}
